<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import { serviceReport, deleteServiceReport, exportReport } from "@/service";
import { formatDatetime } from "@/helpers/common";
import _ from 'lodash';
import AddServiceReport from "@/views/service-report/components/add-service-report";
import {SERVICE_REPORT_TYPE, SERVICE_REPORT_TYPE_TXT} from "@/config/common";
import tableLoading from "@/views/widgets/table-loading";
import {alertComfirm, successMsg, alertError} from "@/helpers/swal";
import i18n from "@/i18n";
import moment from "moment"
const serviceTypeOptions = [
  { label: i18n.global.t('page.allType'), value: '' },
  ...SERVICE_REPORT_TYPE
]

import ServiceReport from "@/views/service-report/components/service-report";

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    woId: {
      type: [Number, String],
      default: 0
    },
    // 工单信息
    woInfo: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      serviceTypeOptions,
      SERVICE_REPORT_TYPE_TXT,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'number',
          label: this.$t('page.report_number'),
          visible: true
        },
        {
          name: 'type',
          label: this.$t('page.type'),
          visible: true
        },
        {
          name: 'root_sn',
          label: this.$t('page.device_serial_number'),
          visible: true
        },
        {
          name: 'device_name_txt',
          label: this.$t('page.device_name'),
          visible: true
        },
        {
          name: 'customer_txt',
          label: this.$t('page.customer'),
          visible: true
        },

        {
          name: 'customer_contact_name',
          label: this.$t('page.contact_person'),
          visible: true
        },
        {
          name: 'customer_contact_department',
          label: this.$t('page.user.department'),
          visible: JSON.parse(localStorage.getItem("user")).user_type==="customer"
        },
        {
          name: 'customer_contact_number',
          label: this.$t('page.contact_phone'),
          visible: true
        },
        {
          name: 'customer_email',
          label: this.$t('page.email'),
          visible: JSON.parse(localStorage.getItem("user")).user_type!=="customer"
        },
        {
          name: 'service_company_txt',
          label: this.$t('page.service_company'),
          visible: true
        },
        {
          name: 'reporter_txt',
          label: this.$t('page.engineer'),
          visible: true
        },
        {
          name: 'reporter_time',
          label: this.$t('page.write_time'),
          visible: true
        },
      ],
      showAllColumns: [],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 2,
      },
      filter_value: {
        keyword: '',
        created_at: '',
        type: null,
      },
    };
  },
  components: {
    Multiselect,
    AddServiceReport,
    tableLoading,
    ServiceReport
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  watch: {

  },
  mounted() {
    this._getFirstPage()
  },

  methods: {
    moment,
    formatDatetime,
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 新建服务报告
    add() {
      this.$refs.addServiceReport.open()
    },
    // 报告导出
    download(id) {
      exportReport(id).then(res => {
        window.open('/service-report-download/' + res.payload.request_id, '_blank', 'noreferrer')
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
      })
    },
    // 删除报告
    del(id) {
      alertComfirm().then(res => {
        if (res) {
          deleteServiceReport(id).then(() => {
            successMsg(this.$t('base.delete_success'))
            this._getList()
          }).catch(err => {
            console.log(err)
            alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
          })
        }
      })
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        created_at_before: null,
        created_at_after: null,
        type: null
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.created_at) {
        search['created_at_before'] = this.filter_value.created_at
        search['created_at_after'] = this.filter_value.created_at
      }
      if (this.filter_value.type) {
        search['type'] = this.filter_value.type
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value.created_at = null
      this.filter_value.type = null
      this.filter_value.keyword = null
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      if (this.woId) {
        this.filters['work_order'] = this.woId
      }
      this.tableLoading = true
      this.tableLoaded = false
      serviceReport(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.dataList.map(item => {
          item.preview_url = false
          if (item.attachment && item.attachment.length > 0) {
            for (var i in item.attachment) {
              let _item = item.attachment[i]
              if (_item.content_type == "application/pdf" || _item.content_type.indexOf("image") != -1) {
                item.preview_url = _item.url
                break
              }
            }
          }
          return item
        })

        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
    clickOpen(){
      this.$refs.serviceReportRef.open()
    },

  },
};
</script>

<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 v-if="showTitle" class="card-title mb-0">{{ $t('page.serviceReport') }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <b-button type="button" variant="primary" class="add-btn" v-perm="'report.post'" @click="add">
                    <i class="ri-add-line align-bottom me-1"></i> {{ $t('page.add') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body v-if="showSearch" class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="4">
                  <div class="search-box">
                    <input type="text" class="form-control search" v-model="filter_value.keyword"
                           :placeholder="user&&user.user_type==='customer'?$t('page.reportNumberCustomerNameAgentDeviceSerial'):$t('page.reportNumberCustomerNameAgentDeviceSerialNumber')" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="3">
                  <div>
                    <flat-pickr :placeholder="$t('page.selectCreationTime')" v-model="filter_value.created_at" :config="config"
                                class="form-control flatpickr-input"></flat-pickr>
                  </div>
                </b-col>
                <b-col xxl="3">
                  <div class="input-light">
                    <Multiselect class="form-control" :placeholder="$t('page.pleaseSelectType')" v-model="filter_value.type" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="serviceTypeOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col xxl="2"  class="d-flex justify-content-end align-items-end">
                  <b-button type="button" variant="primary" class="me-2" @click="doFilter">
                    <i class="ri-search-line me-1 align-bottom"></i>
                    {{ $t('page.filter') }}
                  </b-button>
                  <b-button
                      type="button"
                      variant="info"
                      @click="resetSearch"
                  >
                    <i class="ri-restart-line me-1 align-bottom"></i>
                    {{ $t('page.reset') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th style="width: 200px" v-if="item.name==='reporter_txt'||item.name==='reporter_time'">{{$t(item.label)}}</th>
                      <th v-else v-show="item.visible&&(user&&user.user_type!=='customer'||(user&&user.user_type==='customer'&&(item.label!==$t('page.customer')||item.label===$t('page.user.department'))))">{{ $t(item.label) }}</th>
                    </template>
                    <th>
                      {{ $t('page.operation') }}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-show="titleItem.visible&&(user&&user.user_type!=='customer'||(user&&user.user_type==='customer'&&(titleItem.label!==$t('page.customer')||titleItem.label===$t('page.user.department'))))">
                        <div  class="d-flex align-items-center" v-if="titleItem.name === 'reporter_txt'">
                          <div style="width:25px;text-align: start">{{ item[titleItem.name] }}</div>
                          <div style="margin-left:60px;width:76px;height: 18px;border-radius: 20px;background: #6691E7;font-size: 12px;font-weight: 500;color:#FFFFFF;text-align: center"  v-if="item[titleItem.name]&&item.service_company_type=='1'">{{ $t("page.work-order.factory_engineer") }}</div>
                          <div style="margin-left:60px;width: 76px;height: 18px;border-radius: 20px;background: #8698BC;font-size: 12px;font-weight: 500;color:#FFFFFF;text-align: center" v-if="item[titleItem.name]&&item.service_company_type=='2'">{{ $t("page.work-order.authorized_engineer") }}</div>
                        </div>
                        <span v-else-if="titleItem.name === 'reporter_time'">{{ moment(item[titleItem.name]).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        <span v-else-if="titleItem.name === 'type'">{{ SERVICE_REPORT_TYPE_TXT[item[titleItem.name]] }}</span>
                        <span v-else>{{ item[titleItem.name] }}</span>
                      </td>
                    </template>
                    <td>
                      <a v-if="item.preview_url" class="ri-eye-fill fs-3 text-primary me-3" v-perm="'report.attachment.download'" :href="item.preview_url" target="_blank"></a>
                      <i class="ri-download-cloud-line fs-3 text-primary me-3 cursor-pointer" v-perm="'report.attachment.download'" @click="download(item.id)"></i>
                      <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="del(item.id)"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loaded="tableLoaded" :table-loading="tableLoading"></table-loading>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
    <add-service-report :title="$t('page.create')" ref="addServiceReport" @refresh="_getFirstPage" :wo-id="woId" :init-info="woInfo"></add-service-report>
    <ServiceReport ref="serviceReportRef"></ServiceReport>
  </div>
</template>
